/**
 * Converts file size in bytes to KB or MB with two decimal places
 * @param bytes File size in bytes
 * @returns Formatted string with KB or MB unit
 */
export const formatFileSize = (bytes?: number): string => {
  if (!bytes) return '0 KB';

  const MB_THRESHOLD = 1024 * 1024; // 1MB in bytes

  if (bytes >= MB_THRESHOLD) {
    // Convert to MB and format with two decimal places
    const mb = (bytes / MB_THRESHOLD).toFixed(2);
    return `${mb} MB`;
  }

  // Convert to KB and format with two decimal places
  const kb = (bytes / 1024).toFixed(2);
  return `${kb} KB`;
};
